import { DatePipe } from '@angular/common';
import { Input } from '@angular/core';
import { Output } from '@angular/core';
import { ViewChild } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { HostListener } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectComponent } from '@ng-select/ng-select';

import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogService } from 'src/app/components/confirmation-dialog/confirmation-dialog.service';
import { ComponentCanDeactivate } from 'src/app/components/PendingChangesGuard';
import { AddproductComponent } from 'src/app/components/product/addproduct/addproduct.component';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
@Component({
  selector: 'app-addphysicalstock',
  templateUrl: './addphysicalstock.component.html',
  styleUrls: ['./addphysicalstock.component.css']
})
export class AddphysicalstockComponent implements OnInit, ComponentCanDeactivate {

  @ViewChild('Selecter', { static: false }) ngselect: NgSelectComponent;

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;
  ischeck: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  isload: boolean = true;

  israwmaterialaddmode: boolean = false;

  rtnform: string = "";
  errtxt: any = "";

  //Edit Get Values
  physicalstockmainColl: any = [];
  stockreportColl: any = [];

  physicalstockBO: any = {}

  physicalstockdetailscoll: any = [];
  rawmaterialphysicalColl: any = [];

  ismanualclose: boolean;

  qtytotal: number = 0;
  unitpricetotal: number = 0;
  subtotal: number = 0;
  physicalqty: number = 0;



  productfindColl: any;
  taxColl: any;
  rawmaterialColl: any;
  isLoadingResult: boolean;


  physicalstockform = new FormGroup({
    physicalstockid: new FormControl(0),
    physicalstockno: new FormControl('', Validators.required),
    physicalstockdate: new FormControl(null, Validators.required),
    refno: new FormControl(''),
    descr: new FormControl(''),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Physicalstock";

  gridfocusrow: number = -1;

  @Input() physicalstockid: number = 0
  @Input() filterfromdate: any = null;
  @Input() filtertodate: any = null;
  @Input() formmode: String = "";


  @Output() emitData = new EventEmitter();

  constructor(private appService: DhukanDataService, private activeModal: NgbActiveModal, private route: ActivatedRoute,
    private productFindService: NgbModal, private confirmationDialogService: ConfirmationDialogService,
    public router: Router, private toastr: ToastrService, public loginService: LoginDataService, private datePipe: DatePipe) {

    this.fnServiceChanges();
  }


  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {

          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }

        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.physicalstockform.reset();
      this.fnInitializeForm();


      if (this.physicalstockid > 0) {
        this.fngetPhysicalstock();
      }
      else {
        this.fngetRawmaterialPhysicalstock();
        //this.fnSetFirstRowItem()
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  ngAfterViewInit() {
    //  this.loginService.fnSetFirstControlFocusLookup(this.ngselect);


  }





  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.physicalstockid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }
    this.israwmaterialaddmode = this.loginService.fnCheckUserRoleAction("Rawmaterial", 'CREATE')

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeForm() {
    this.physicalstockform.setValue({
      physicalstockid: 0,
      physicalstockno: 'NEW',
      physicalstockdate: new Date(),
      descr: null,
      refno: '',
      inactive: false,
    })
  }








  //Get 
  fngetPhysicalstock() {

    var data = {
      'physicalstockid': this.physicalstockid,
      'companyid': this.loginService.fnGetCompanyId()

    }
    this.appService.getPhysicalstock(data)
      .subscribe(
        (res) => {
          var result = res.json().result;
          console.log(res.json())
          this.physicalstockmainColl = result[0];

          var editdata = this.physicalstockmainColl[0];
          this.physicalstockBO = editdata;
          this.fnEditMode(editdata);

          this.physicalstockdetailscoll = result[1];

          if (this.physicalstockdetailscoll.length === 0) {
            this.fnSetFirstRowItem()
          }
          // this.fnCalcDetails();
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Get
  fngetStockReport() {
    this.fnShowProgress()
    var data = {
      'ondate': this.fnFormatDatetime(this.physicalstockform.get("physicalstockdate").value),
      'companyid': this.loginService.fnGetCompanyId(),
      'groupid': 0,
      'productid': 0,
    }

    this.appService.getStockReport(data)
      .subscribe(
        (res) => {
          this.fnHideProgress()
          if (res.json().status === 200) {
            this.stockreportColl = res.json().result;
            console.log(this.stockreportColl)


            for (let abo of this.physicalstockdetailscoll) {
              var acoll=this.stockreportColl.filter((x)=>x.rawmaterialid===abo.rawmaterialid)
                if(acoll.length>0){
                  abo.currentstock=acoll[0].currentstock;
                }
            }

          } else {

          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  // fnValidation() {
  //   var _ischeck = false;
  //   var _detailscheck = false;

  //   for (let row of this.physicalstockdetailscoll) {
  //     if (row.productid > 0) {
  //       _detailscheck = true;
  //     }
  //   }

  //   if (!_detailscheck) {
  //     this.errtxt = "Physicalstock Details cannot be empty"
  //     this.physicalstockform.controls['inactive'].setErrors({ 'notfound': true });
  //     _ischeck = true;
  //   }
  //   if (!_ischeck) {
  //     for (let row of this.physicalstockdetailscoll) {

  //       if (row.productid > 0 && this.loginService.fnCheckZeroDetcimal(row.physicalqty) === 0) {
  //         this.errtxt = "Quantity is cannot be empty"
  //         this.physicalstockform.controls['inactive'].setErrors({ 'notfound': true });
  //         _ischeck = true;
  //       }

  //     }
  //   }
  //   return _ischeck;

  // }

  fnResetValidation() {

    if (this.physicalstockform.get('inactive')) {
      this.physicalstockform.controls['inactive'].setErrors(null);
    }

  }


  //Save Btn Click
  fnSaveBtnClick() {

    try {
      if (this.saveloading) {
        return;
      }

      this.submitted = true;
      this.successfully = false;

      this.fnResetValidation()
      //Validate

      if (this.physicalstockform.valid) {

        // if (this.fnValidation()) {

        //   return false
        // }


        this.saveloading = true;



        //Check
        var data = {
          'physicalstockid': this.physicalstockid,
          'physicalstockno': this.physicalstockform.get('physicalstockno').value,
          'physicalstockdate': this.fnFormatDatetime(this.physicalstockform.get('physicalstockdate').value),
          'descr': this.physicalstockform.get('descr').value,
          'refno': this.physicalstockform.get('refno').value,
          'inactive': this.physicalstockform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
          'physicalstockdetailscoll': this.physicalstockdetailscoll,
        }

        if (this.physicalstockform.get('physicalstockid').value > 0) {

          this.fnSetPhysicalstock(data);
        }
        else {

          this.fnInsertPhysicalstock(data);
        }

      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }

  }

  //Insert
  fnInsertPhysicalstock(data) {

    this.appService.fnInsertPhysicalstock(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status == 200) {
          this.toastr.success('', "The new Physicalstock has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.physicalstockno);

          var _result = res.json().result;
          if (_result.length > 0) {
            this.fnEditFormEdit(_result[0].physicalstockid);
          }

        } else {
          this.toastr.error('Error', res.json().err_message);
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetPhysicalstock(data) {

    this.appService.fnSetPhysicalstock(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status == 200) {
          this.toastr.success('', "The Physicalstock has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.physicalstockid, data.physicalstockno);

          this.fnEditFormEdit(this.physicalstockid);
        } else {
          this.toastr.error('Error', res.json().err_message);
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }


  private fnEditMode(deptBO) {

    deptBO.physicalstockdate = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.physicalstockdate));


    this.physicalstockform.setValue({

      physicalstockid: deptBO.physicalstockid,
      physicalstockno: deptBO.physicalstockno,
      physicalstockdate: deptBO.physicalstockdate,
      descr: deptBO.descr,
      refno: deptBO.refno,
      inactive: deptBO.inactive,

    });




    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = false;

    if (this.formmode === 'EDIT') {
      this.iseditmode = true;
    }
    else {
      this.isviewmode = true;
    }

    this.isviewmode = true;
  }


  fnEditBtnClick() {
    this.iseditmode = true;

    this.isviewmode = false;
  }




  fnEditFormEdit(id) {

    this.physicalstockid = id;
    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;


    //this.ngOnInit();

    this.ismanualclose = true;
    this.fnCloseForm();

  }

  //Close
  async fnCloseForm() {

    try {

      if ((this.isaddmode || this.iseditmode) && !this.ismanualclose) {
        var a = await this.loginService.fnConfirmFormLeave();
        if (a === false) {
          return false;
        }
      }

      this.ismanualclose = true;


      this.emitData.emit("");
      this.activeModal.close(true);

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  @HostListener('window:beforeunload')
  canDeactivate(): any {

    if (this.ismanualclose || this.isviewmode) {
      return true;
    }
    else {
      return false;
    }
  }


  fngetRawmaterialPhysicalstock() {

    var data = {
      'ondate': this.filterfromdate,
      'companyid': this.loginService.fnGetCompanyId()

    }
    this.appService.getRawmaterialPhysicalstock(data)
      .subscribe(
        (res) => {

          this.rawmaterialphysicalColl = res.json().result[0];
          this.physicalstockdetailscoll = this.rawmaterialphysicalColl

          this.fngetStockReport();

          //console.log(this.physicalstockdetailscoll)

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fnCalcDetails() {

    for (let row of this.physicalstockdetailscoll) {
      row.varianceqty = row.physicalqty - row.currentstock;

    }

  }









  fnSetFirstRowItem() {
    if (this.physicalstockdetailscoll.length > 0) {
      if (!this.physicalstockdetailscoll[this.physicalstockdetailscoll.length - 1].rawmaterialid) {
        return
      }
    }

    var data = {
      physicalstockdetailsid: 0,
      physicalstockid: 0,
      rawmaterialid: null,
      rawmaterialname: '',
      physicalqty: 0,
      currentstock: 0,
      varianceqty: 0,

    }

    this.physicalstockdetailscoll.push(data)

  }






  //Print
  // private fnPrintphysicalstock() {

  //   const modalRef = this.productFindService.open(PrintComponent, { size: <any>'l', backdrop: 'static' });
  //   modalRef.componentInstance.trxid = this.physicalstockid;
  //   modalRef.componentInstance.doctype = this.formname;

  //   modalRef.componentInstance.emitData.subscribe((receivedEntry) => {



  //   });

  // }
  //Print
  // private fnGldetails() {

  //   const modalRef = this.productFindService.open(GldetailscommonComponent, { size: <any>'l', backdrop: 'static' });
  //   modalRef.componentInstance.trxid = this.physicalstockid;
  //   modalRef.componentInstance.doctype = this.formname;

  //   modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

  //   });

  // }

  fnPostingConfirm(type) {
    this.confirmationDialogService.confirm('Confirm..', 'Do you  want to ' + type + ' Physical Stock?')
      .then((confirmed) => {
        if (confirmed) {
          if (type === 'Post') {
            this.fnPosting()
          }
          else if (type === 'UnPost') {
            this.fnUnPosting()
          }

        }
      }
      );
  }


  fnPosting() {
    var data = {
      trxid: this.physicalstockid,
      doctype: 'PHYSICALSTOCK',
      postingtype: 'MANUAL',
      modifiedby: this.loginService.fnGetModUserId()

    }
    this.appService.fnInsertPostings(data)
      .subscribe(
        (res) => {

          if (res.json().status === 200) {

            this.fnEditFormEdit(this.physicalstockid);
          }
          else {
            this.toastr.error('Error', res.json().err_message);
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fnUnPosting() {
    var data = {
      trxid: this.physicalstockid,
      doctype: 'PHYSICALSTOCK',
      postingtype: 'MANUAL',
      modifiedby: this.loginService.fnGetModUserId()

    }
    this.appService.fnInsertUnPostings(data)
      .subscribe(
        (res) => {

          if (res.json().status === 200) {

            var result = res.json().result;

            if (result.length > 0) {

              if (result[0].checkresult === 'DONE') {
                this.fnEditFormEdit(this.physicalstockid);
              }
              else {
                this.toastr.error('Error', result[0].checkresultmsg);
              }
            }

          }
          else {
            this.toastr.error('Error', res.json().err_message);
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }



  fnEnableEditBtn() {
    if (this.physicalstockBO.iscancelled === 1) {
      return false;
    }
    else if (this.physicalstockBO.isposted === 1) {
      return false;
    }
    else {
      return true;
    }
  }

  fnEnablePostBtn() {
    if (this.physicalstockBO.iscancelled === 1) {
      return false;
    }
    else if (this.physicalstockBO.isposted === 1) {
      return false;
    }
    else {
      return true;
    }
  }



  fnEnableUnPostBtn() {
    if (this.physicalstockBO.isposted === 1) {
      return true;
    }
    else {
      return false;
    }

  }

  fnChechProduct(event, pBO) {
    if (event.target.checked === false) {
      pBO.physicalqty = null;
    }
  }


  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId()

      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }

  fnConvertDecimal(value) {
    if (!value) {
      return 0
    }
    else {
      return value
    }

  }


  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }
  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }




  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }

  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }






}
